import { BrowserRouter, Routes, Route } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

import Homepage from "./pages/Homepage.js";
import PersonalInfo from "./components/application/personalinfo/PersonalInfo.js";
import TrustedIndividual from "./components/application/trustedindividual/TrustedIndividual.js";
import DependantDetails from "./components/application/dependant/DependantDetails.js";

import Objectives from "./components/application/financial/objectives/Objectives.js";
import IncomeAndExpenses from "./components/application/financial/incomeandexpenses/IncomeAndExpenses.js";
import AssetsAndLiabilities from "./components/application/financial/assetsandliabilities/AssetsAndLiabilities.js";
import CurrentPlans from "./components/application/currentplans/CurrentPlans.js";

import InvestmentRisk from "./components/application/riskprofile/InvestmentRisk.js";
import CustomerKnowledgeAndAccounts from "./components/application/riskprofile/ckacar/CustomerKnowledgeAndAccounts.js";

import Affordability from "./components/application/affordability/Affordability.js";
import NeedsAnalysis from "./components/application/needsanalysis/NeedsAnalysis.js";

import ProductInsurance from "./components/application/products/insurance/ProductInsurance.js";
import ProductInvestment from "./components/application/products/investment/ProductInvestment.js";

import Summary from "./components/application/summary/Summary.js";

import PageNotFound from "./pages/PageNotFound.js";

import CssBaseline from "@mui/material/CssBaseline";
import { Container } from "@mui/material";

import TitleBar from "./components/TiitleBar.js";
import AppLayout from "./components/application/AppLayout.js";
import Footer from "./components/Footer.js";

function App() {
  return (
    <>
      <CssBaseline />

      <Container
        sx={{
          display: "flex",
          flexDirection: "column",

          height: "100vh",
          bgcolor: "#FFFFFF",
          alignItems: "stretch", //Stretch, start, center, end

          // border: `1px solid black`,
        }}
      >
        {/* <Typography sx={{ border: 3, p: 1, m: 10 }}> Testing text</Typography>*/}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            // border: "1px solid red",
          }}
        >
          {/* TOP LEVEL TITLE BAR */}
          <Grid container spacing={2} columns={12} sx={{ mb: 2 }}>
            <TitleBar />
          </Grid>

          {/* MID LEVEL SIDEBAR & APPLAYOUT */}
          <Grid container spacing={2} columns={12} sx={{ mb: 2 }}>
            <BrowserRouter>
              <Routes>
                <Route index path="/" element={<Homepage />} />

                <Route path="/application" element={<AppLayout />}>
                  <Route path="personalinfo" element={<PersonalInfo />} />

                  <Route path="trustedindividual" element={<TrustedIndividual />} />
                  <Route path="dependantdetails" element={<DependantDetails />} />

                  <Route path="objectives" element={<Objectives />} />
                  <Route path="incomeandexpenses" element={<IncomeAndExpenses />} />
                  <Route path="assetsandliabilities" element={<AssetsAndLiabilities />} />

                  <Route path="currentplans" element={<CurrentPlans />} />
                  {/* <Route path="riskprofile" element={<RiskProfile />} /> */}
                  <Route path="riskinvestment" element={<InvestmentRisk />} />
                  <Route path="riskcka" element={<CustomerKnowledgeAndAccounts />} />

                  <Route path="affordability" element={<Affordability />} />
                  <Route path="needsanalysis" element={<NeedsAnalysis />} />
                  <Route path="summary" element={<Summary />} />

                  <Route path="products">
                    <Route path="insurance" element={<ProductInsurance />} />
                    <Route path="investment" element={<ProductInvestment />} />
                  </Route>
                </Route>

                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </BrowserRouter>
          </Grid>

          {/* LOWER LEVEL - FOOTER*/}
          <Grid container spacing={2} columns={12} sx={{ mb: 2 }}>
            <Footer />
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default App;
